import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FormSummary } from "../components/FormSummary";
import { ISummaryProps } from "../types";

export const FormSummaryPage: FC = () => {
  const location = useLocation();
  const [summary, setSummary] = useState<ISummaryProps>({} as ISummaryProps);

  useEffect(() => {
    const loadedSummary = location.state.summary;
    setSummary(loadedSummary);
    console.log(loadedSummary);
  }, [location.state.summary]);

  return (
    <div className="mx-auto">
      <FormSummary summaryProps={location.state.summary} />
    </div>
  );
};
